export abstract class AccordionItemBase {
  abstract get expanded(): boolean;
  abstract toggle(): void
}